import { _ } from "vue-underscore";

const state = {
  searchFields: [
    {
      name: "Дата",
      key: "date_range",
      type: "date",
      show: true,
      value: []
    },
    {
      name: "Предприятие",
      key: "merchants",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "Терминал",
      key: "terminals",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "Терминал контрагента",
      key: "split_terminals",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "№ заказа MAP",
      key: "map_orders",
      type: "text",
      show: true,
      value: []
    },
    {
      name: "№ заказа Продавца",
      key: "merchant_orders",
      type: "text",
      show: true,
      value: []
    },
    {
      name: "Сумма",
      key: "amount_range",
      type: "text",
      show: true,
      value: []
    },
    {
      name: "Номер карты",
      key: "pan_masks",
      type: "text",
      show: true,
      value: []
    },
    {
      name: "Держатель карты",
      key: "card_holders",
      type: "text",
      show: true,
      value: []
    },
    {
      name: "Статус",
      key: "states",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "Процессинг",
      key: "processings",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "RRN",
      key: "rrns",
      type: "text",
      show: true,
      value: []
    },
    {
      name: "Решение АФ",
      key: "antifraud_decisions",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "Причина отказа",
      key: "processing_errors",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "Банк-эмитент",
      key: "bank_names",
      type: "select",
      show: true,
      value: []
    },
    {
      name: "Только выплаты",
      key: "is_payout",
      type: "bool",
      show: true,
      value: false
    },
    {
      name: "Только СБП",
      key: "is_ips",
      type: "bool",
      show: true,
      value: false
    },
    {
      name: "Только рекурренты",
      key: "is_recurrent",
      type: "bool",
      show: true,
      value: false
    },
    {
      name: "Фискальный чек",
      key: "is_receipt",
      type: "bool",
      show: true,
      value: false
    }
  ]
};

const mutations = {};

const actions = {};

const getters = {
  searchOptions(state) {
    return state.searchFields;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
